import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="redirect"
export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 3000 }
  }

  connect() {
    setTimeout(() => {
      Turbo.visit(this.urlValue)
    }, this.delayValue)
  }
}